<template>
    <Head title="Log in">
        <meta name="robots" content="noindex,nofollow">
    </Head>

    <div class="relative lg:fixed h-full shrink-0 justify-center md:px-12 lg:px-0 bg-white">
        <div class="relative z-10 flex flex-1 flex-col h-full bg-white px-4 py-10 shadow-2xl md:flex-none md:px-28 overflow-y-scroll overflow-x-hidden scrollbar-hide">
            <jet-authentication-card class="">
                <div class="flex justify-center items-center">
                    <jet-authentication-card-logo-colored />
                </div>

                <h1 class="text-lg font-semibold text-gray-900 text-center mt-5">Sign in to your account</h1>
                <p class="mt-8 text-sm text-gray-700">Don’t have an account?<br>
                    Create a <span class="font-bold">free </span>
                    <Link :href="route('agent')" class="underline text-sm text-blue-600 hover:text-gray-900">Manager</Link> or
                    <Link :href="route('applicant')" class="underline text-sm text-blue-600 hover:text-gray-900">Renter</Link> account
                </p>

                <jet-validation-errors class="mb-4" />

                <div v-if="status" class="mb-4 font-medium text-sm">
                    <div v-if="status.includes('blocked from accessing RentRisk')" class="text-red-600">
                        Your email has been blocked from accessing RentRisk. Please 
                        <a href="https://rentrisk.com/contact" class="underline text-blue-600 hover:text-blue-800">contact support</a> 
                        if you need assistance.
                    </div>
                    <div v-else class="text-green-600">
                        {{ status }}
                    </div>
                </div>

                <form @submit.prevent="submit" aria-label="Login Form" class="mt-6 grid grid-cols-1 gap-y-6">
                    <div>
                        <jet-label for="email" value="Email" class="mb-3 block text-sm font-medium text-gray-700" />
                        <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus />
                    </div>
                    <div class="">
                        <jet-label for="password" value="Password" class="text-gray-400" />
    <!--                    <jet-input id="password" type="password" class="mt-1 block w-full border-gray-100 drop-shadow-xl" v-model="form.password" required autocomplete="current-password" />-->
                        <div class="relative mt-2 flex items-center">
                            <input :type="isShowPassword ? 'text' : 'password'" id="password" v-model="form.password" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm block w-full" />
                            <div class="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
                                <button type="button" @click="isShowPassword = !isShowPassword" class="inline-flex items-center rounded border border-gray-200 px-1 font-sans text-xs" :class="isShowPassword ? 'text-gray-500' : 'text-blue-600'"><font-awesome-icon icon="fa-eye" /></button>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label class="flex items-center">
                            <jet-checkbox name="remember" class="border-gray-100" v-model:checked="form.remember" />
                            <span class="ml-2 text-sm text-gray-700">Remember me</span>
                        </label>
                    </div>

                    <div class="flex items-center justify-end">
                        <jet-button custom_class="group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-black active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600 w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Sign in <font-awesome-icon :icon="faRightToBracket" class="text-white ml-3"></font-awesome-icon>
                        </jet-button>
                        <input type="hidden" id="user_prefs" name="user_prefs"> <input type="hidden" id="user_prefs2" name="user_prefs2">
        <!--                <a class="btn" :href="route('facebook.login')"-->
        <!--                   style="background: #3B5499; color: #ffffff; padding: 10px; width: 100%; text-align: center; display: block; border-radius:3px;">-->
        <!--                    Login with Facebook-->
        <!--                </a>-->
                    </div>
                    <div>
                        <Link v-if="canResetPassword" :href="route('password.request')" class="text-sm text-gray-900">
                            Forgot password ?
                        </Link>
                    </div>
                    <div v-if="1 === 0" class="flex items-center justify-between">
                        <a href="login/facebook" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-rent-risk-blue-400 disabled:bg-indigo-300 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400" style="background-color: #3b5998">
                            Login with Facebook
                        </a>
                        <a href="login/google" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-rent-risk-blue-400 disabled:bg-indigo-300 hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-rent-risk-blue-400" style="background-color: #DB4437">
                            Login with Google
                        </a>
                    </div>
                </form>
            </jet-authentication-card>
        </div>
        <div class="bg-white">
            <div class="mx-auto py-4 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
                <div class="flex justify-center space-x-6 md:order-3 md:mt-6">
                    <div class="flex justify-right justify-around flex-col text-sm text-gray-300">
                        <div class="flex flex-row text-purple-400">
                            <a href="tel:5403648271" class="text-purple-400 hover:text-gray-300 hover:border-golden-100 border-b-2 border-transparent pt-1">Call Us</a> <span class="pt-1">|</span>
                            <jet-nav-link :href="route('privacy-policy')" :overrideClass="'text-purple-400'">Privacy Policy</jet-nav-link> <span class="pt-1">|</span>
                            <jet-nav-link :href="route('terms-and-conditions')" :overrideClass="'text-purple-400'">Terms and Conditions</jet-nav-link> <span class="pt-1">|</span>
                            <jet-nav-link :href="route('dispute')" :overrideClass="'text-purple-400'">Dispute</jet-nav-link>
                        </div>
                    </div>
                </div>
                <div class="mt-4 md:mt-0 md:order-1 md:pt-6">
                    <p class="text-center text-base text-purple-400">
                        &copy; {{currentYear}} Rent Risk, LLC. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="hidden md:flex lg:pl-72 h-screen rentrisk-sidebar-gradient"></div>
    <maintenance-notice-modal />
</template>

<script>
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrorsWithHtml.vue'
    import { Head, Link } from '@inertiajs/vue3';
    import moment from "moment";
    import JetNavLink from '@/Jetstream/NavLink.vue'
    import AcceptCookies from "@/Pages/GDPR/AcceptCookies.vue";
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {faRightToBracket} from "@fortawesome/pro-light-svg-icons";
    import { useForm } from '@inertiajs/vue3'
    import Button from "@/Jetstream/Button.vue";
    import MaintenanceNoticeModal from '@/Shared/MaintenanceNoticeModal.vue';

    export default {
        components: {
            MaintenanceNoticeModal,
            Button,
            AcceptCookies,
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetAuthenticationCardLogoColored,
            JetButton,
            JetInput,
            JetCheckbox,
            JetLabel,
            JetValidationErrors,
            Link,
            JetNavLink,
            FontAwesomeIcon,
            faRightToBracket
        },

        props: {
            canResetPassword: Boolean,
            status: String,
        },

        data() {
            return {
                currentYear: moment().year(),
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false
                }),
                isShowPassword: false,
            }
        },

        methods: {
            submit() {
                adx.validate('user_prefs');
                this.form
                    .transform(data => ({
                        ... data,
                        remember: this.form.remember ? 'on' : ''
                    }))
                    .post(this.route('login'), {
                        onFinish: () => this.form.reset('password'),
                    })
            },
            beforeMount() {
                adx.initiate(null)
            },
        }
    }
</script>
